import './Loading.scss';

export default function Loading({
    fullScreen = false,
    message = '',
    submessage = ''
}) {
    return (
        <div className={`loading-shell ${fullScreen ? 'loading-shell--fullscreen' : ''}`}>
            <div className="loading-content" role="status" aria-live="polite">
                <div className="loading-spinner" aria-hidden="true" />
                {message ? <p className="loading-message">{message}</p> : null}
                {submessage ? <p className="loading-submessage">{submessage}</p> : null}
            </div>
        </div>
    );
}
